import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  OnDestroy
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { ButtonType } from '@ascschool/interface/setting';
import { CommonFilter } from '@ascschool/model/commonfilter/commonfilter';
import { AuthQuery } from '@ascschool/core/auth/auth.query';
import { AuthService } from '@ascschool/core/auth/auth.service';
import { ConfirmComponent } from '@ascschool/project/popups/confirm/confirm.component';
import { SizePageService } from '@ascschool/project/size-page/size-page.service';
import { UtilsService } from '@ascschool/services/utils.service';
import { ShortcutInput } from 'ng-keyboard-shortcuts';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { NzUploadChangeParam } from 'ng-zorro-antd/upload';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';  
import { Group } from '@ascschool/model/user/group.model'; 
import { TypeOfPersonnelService } from '@ascschool/services/category/type-of-personnel.service';
import { TypeOfDisabilityService } from '@ascschool/services/category/typeofdisability.service';
import { ProvinceService } from '@ascschool/services/category/province.service';
import { SchoolService } from '@ascschool/services/organization/school.service';
import { StaffTypeOfDisabilityService } from '@ascschool/services/user/staff-typeofdisability.service';  
import { PopUpGiaoVienPhuTrachComponent } from './popup-giao-vien-phu-trach/popup-giao-vien-phu-trach.component';
import { ThemNguoiKhuyetTatComponent } from './them-nkt/them-nkt.component';
import { DanhSachNguoiKhuyetTatComponent } from './danh-sach-nkt/danh-sach-nkt.component';
import { ThemGiaoVienPhuTrachComponent } from './them-giao-vien-phu-trach/them-giao-vien-phu-trach.component';
import { Subject } from 'rxjs';
import {takeUntil} from 'rxjs/operators'
@Component({
  selector: 'app-phan-cong-giao-vien-phu-trach',
  templateUrl: './phan-cong-giao-vien-phu-trach.component.html',
  styleUrls: ['./phan-cong-giao-vien-phu-trach.component.scss']
})
export class PhanCongGiaoVienPhuTrachComponent implements OnInit,OnDestroy, AfterViewInit {
  isResizdePopup: boolean;
  dialogRef: NzModalRef;
  titlePopup: string;
  heightModal: string;
  widthModal: string;
  @ViewChild('tplTitle', { static: false }) titlePopupElement;
  get breadcrumbs(): string[] {
    return ['Quản lý người khuyết tật'];
  }
  constructor(
    private msg: NzMessageService,
    private cdRef: ChangeDetectorRef,
    public _authService: AuthService,
    public sizePageService: SizePageService,
    private modalService: NzModalService,
    private authQuery: AuthQuery,
    private typeOfPersonnelService: TypeOfPersonnelService,
    private typeOfDisabilitysService: TypeOfDisabilityService,
    private provinceService: ProvinceService,
    private schoolService: SchoolService,
    private utilsService: UtilsService,
    private service: StaffTypeOfDisabilityService,
  ) { 
    this.currentUser = JSON.parse(localStorage.getItem('userSetting'));

  }
  // get breadcrumbs(): string[] {
  //   return ['Quản trị hệ thống'];
  // }
  // tslint:disable-next-line: adjacent-overload-signatures
  @ViewChild('pageHeaderTable', { static: false }) set content2(content2: ElementRef) {
    if (content2) {
      // initially setter gets called with undefined
      this.elementPageHeaderTable = content2;
    }
  }
  $unSubscribe =new Subject();
  searchTerm: string = '';
  pageIndex: number = 1;
  pageSizeOptions: number[] = [50, 100, 200];
  pageSize: number = this.pageSizeOptions[0];
  loading: boolean = true;
  Total: number = 0;
  firstRowOnPage: any;
  searchAdvanced = true;
  checkedAll: boolean = false;
  commonFilter = new CommonFilter();
  systemuserList: any;
  listGroupSelected: number[] = [];

  getTypeOfPersonnelACFn: (value: any) => Observable<any>;
  typeOfPersonnelSubscription: any;
  typeOfPersonnelControl = new FormControl();

  getTypeOfDisabilitysACFn: (value: any) => Observable<any>;
  typeOfDisabilitysSubscription: any;
  typeOfDisabilitysControl = new FormControl();

  getProvinceACFn: (value: any) => Observable<any>;
  provinceSubscription: any;
  provinceControl = new FormControl();

  getSchoolACFn: (value: any) => Observable<any>;
  schoolSubscription: any;
  schoolControl = new FormControl();


  currentUser: any;
  checked = false;
  indeterminate = false;
  listOfCurrentPageData: any[] = [];
  setOfCheckedId = new Set<number>();
  buttonTypeEnum = ButtonType;
  btnType: ButtonType;
  shortcuts: ShortcutInput[] = [];
  totalSchool: number;
  width: number;
  numberControl: number;
  private elementPageHeaderTable: ElementRef;
  @ViewChild('pageSample8', { static: false }) elementPageSample8: ElementRef;
  @ViewChild('pageOptionBtnGroup', { static: false }) elementpageOptionBtnGroup: ElementRef;
  @ViewChild('pageSearch', { static: false }) elementPageSearch: ElementRef;
  show = false;
  maxHeight: number;
  height: number;
  heightPopup: number;
  heightPagnagation: number = 50;
  isCollapse = true;

  sortNameFn = (a: Group, b: Group) => a.groupName.localeCompare(b.groupName);

  ngOnInit() {
    this.commonFilter.PageIndex = 1;
     this.commonFilter.PageSize = this.pageSizeOptions[0];
   
    if (this.currentUser.accountType === 3) {
      this.commonFilter.SchoolId = this.currentUser.eadId;
      this.commonFilter.ProvinceId = this.currentUser.provinceId;
    }
    this._authService.getNavChangeEmitter().subscribe(() => {
      this.checkCaculateHeight();
    });
    this.authQuery.userSetting$.subscribe((type) => {
      if (type) {
        this.btnType = type.btnType;
      }
    });
    this.reload();
    this.loadTypeOfPersonnel();
    this.loadTypeOfDisabilitys();
    this.loadProvince();
  }

  valueIfHas(control: FormControl) {
    if (control.value && typeof control.value != 'string') { return control.value.id; }
    return '';
  }

  loadProvince() {
    this.getProvinceACFn = (value: any) => this.provinceService.GetSelectPagingProvinceBySubordinateType({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.length > 0 ? resp.map(x => ({ id: x.id, text: x.provinceName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.provinceSubscription) {
      this.provinceSubscription = this.provinceControl.valueChanges.subscribe(() => {
        this.utilsService.bindOrUnBindTheId(this.commonFilter, 'ProvinceId', this.provinceControl.value);
      });
    }
  }

  changeProvince(control: FormControl) {
    if (control.value) {
      this.provinceControl = control;
      this.loadSchool();
      this.schoolControl.setValue(null);
    }

  }

  loadSchool() {
    this.getSchoolACFn = (value: any) => this.schoolService.getSelectPagingForStaff({ searchTerm: value, ProvinceId: this.valueIfHas(this.provinceControl), PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.educationAndTrainingName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.schoolSubscription) {
      this.schoolSubscription = this.schoolControl.valueChanges.subscribe(() => {
        this.utilsService.bindOrUnBindTheId(this.commonFilter, 'SchoolId', this.schoolControl.value);
      });
    }
  }

  changeSchool(control: FormControl) {
    this.schoolControl = control;
  }

  loadTypeOfPersonnel() {
    this.getTypeOfPersonnelACFn = (value: any) => this.typeOfPersonnelService.getTypeOfPersonnelSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.typeOfPersonnelName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.typeOfPersonnelSubscription) this.typeOfPersonnelSubscription = this.typeOfPersonnelControl.valueChanges.subscribe(() => {
      this.utilsService.bindOrUnBindTheId(this.commonFilter, 'TypeOfPersonnelId', this.typeOfPersonnelControl.value);
    });
  }
  changeTypeOfPersonnel(control: FormControl) {
    this.typeOfPersonnelControl = control;
  }

  loadTypeOfDisabilitys() {
    this.getTypeOfDisabilitysACFn = (value: any) => this.typeOfDisabilitysService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.typeOfDisabilityName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.typeOfDisabilitysSubscription) this.typeOfDisabilitysSubscription = this.typeOfDisabilitysControl.valueChanges.subscribe(() => {
      this.utilsService.bindOrUnBindTheId(this.commonFilter, 'TypeOfDisabilityId', this.typeOfDisabilitysControl.value);
    });
  }
  changeTypeOfDisabilitys(control: FormControl) {
    this.typeOfDisabilitysControl = control;
  }

  reload() {
    const _this = this;
    this.loading = true;
    _this.systemuserList = [];
    this.service.getStaffTypeOfDisability(this.commonFilter).pipe(takeUntil(this.$unSubscribe)).subscribe(
      (response: any) => {
        const list = response.results ? response.results : [];
        this.Total = (response && response.rowCount) ? response.rowCount : 0;
        this.firstRowOnPage = (response && response.firstRowOnPage) ? response.firstRowOnPage : 0;
        _this.systemuserList = (list) ? list : [];
        _this.loading = false;
      },
      (err: any) => {
        _this.systemuserList = [];
        _this.loading = false;
      }
    );
  }
  search() {
    this.commonFilter.PageIndex = 1;
    this.reload();
  }
  pageIndexEvent(pageE: any) {
    this.commonFilter.PageIndex = pageE;
    this.pageIndex = pageE;
    this.reload();
  }
  pageSizeEvent(pageE: any) {
    this.commonFilter.PageSize = pageE;
    this.pageSize = pageE;
    this.reload();
  }
  ngAfterViewInit() {
    this.checkCaculateHeight(this.isCollapse);
    // keyboard
    this.shortcuts.push({
      key: ['alt + n'],
      label: 'Help',
      description: 'Cmd + b',
      command: (e) => this.Add(),
      preventDefault: true
    });
    this.cdRef.detectChanges();
  }
  isDivisibleForFour(index: number) {
    if (index % 4 === 0) {
      return true;
    } else {
      return false;
    }
  }
  checkCaculateHeight(isOpen?: boolean) {
    setTimeout(() => {
      this.height = this.heightfnc();
      this.width = this.widthfnc();
    }, 1);
  }
  heightfnc() {
    return this.sizePageService.caculateHeight(
      this.elementpageOptionBtnGroup,
      this.elementPageSearch,
      this.elementPageHeaderTable,
      this.heightPagnagation
    );
  }
  widthfnc() {
    return this.sizePageService.caculateWidth(this.elementPageSearch);
  }
  caculateHeightPopup(maxHeight: number): number {
    let heightModal: number;
    if (maxHeight > 950) {
      return (heightModal = 700 + (maxHeight - 860));
    } else {
      return (heightModal = 700 - (860 - maxHeight));
    }
  }
  onResize() {
    this.width = this.widthfnc();
    this.checkCaculateHeight(this.isCollapse);
  }
  handleChange(info: NzUploadChangeParam): void {
    if (info.file.status !== 'uploading') {
    }
    if (info.file.status === 'done') {
      this.msg.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === 'error') {
      this.msg.error(`${info.file.name} file upload failed.`);
    }
  }
  toggleCollapse(): void {
    this.maxHeight = window.innerHeight;
    this.isCollapse = !this.isCollapse;
    this.checkCaculateHeight(this.isCollapse);
  }
  resetForm(): void { }
  //popup
  showPopup(item: any): void {
    this.isResizdePopup = false;
    this.titlePopup = 'Chỉnh sửa giáo viên phụ trách';
    this.heightModal = 'auto';
    this.widthModal = 700 + 'px';
    this.dialogRef = this.modalService.create({
      nzTitle: this.titlePopupElement,
      nzContent: PopUpGiaoVienPhuTrachComponent,
      nzStyle: { top: '30px' },
      nzMaskClosable: false,
      nzBodyStyle: {
        overflow: 'auto',
      },
      nzComponentParams: {
        dataTransmission: item,
      },
      nzWidth: 700
    });
    this.dialogRef.afterClose.subscribe(result => {
      if (result) {
        this.reload();
      }
    });
  }
  Edit(item: any) {
    this.showPopup(item);
  }
  Add() {
    if (this.currentUser.accountType === 3) {
      this.isResizdePopup = false;
      this.titlePopup = 'Thêm giáo viên phụ trách';
      this.heightModal = this.caculateHeightPopup(window.innerHeight) + 'px';
      this.widthModal = 1300 + 'px';
      this.dialogRef = this.modalService.create({
        nzTitle: this.titlePopupElement,
        nzContent: ThemGiaoVienPhuTrachComponent,
        nzStyle: { top: '30px' },
        nzMaskClosable: false,
        nzBodyStyle: {
          overflow: 'auto',
          height: this.caculateHeightPopup(window.innerHeight) + 'px'
        },
        nzComponentParams: {
          SchoolId: this.commonFilter.SchoolId
        },
        nzWidth: 1300
      });

      this.dialogRef.afterClose.subscribe(result => {
        if (result) {
          this.reload();
        }
      });
    }else{
      if(this.commonFilter.SchoolId && this.commonFilter.SchoolId != null){
        this.isResizdePopup = false;
        this.titlePopup = 'Thêm giáo viên phụ trách';
        this.heightModal = this.caculateHeightPopup(window.innerHeight) + 'px';
        this.widthModal = 1300 + 'px';
        this.dialogRef = this.modalService.create({
          nzTitle: this.titlePopupElement,
          nzContent: ThemGiaoVienPhuTrachComponent,
          nzStyle: { top: '30px' },
          nzMaskClosable: false,
          nzBodyStyle: {
            overflow: 'auto',
            height: this.caculateHeightPopup(window.innerHeight) + 'px'
          },
          nzComponentParams: {
            SchoolId: this.commonFilter.SchoolId
          },
          nzWidth: 1300
        });
  
        this.dialogRef.afterClose.subscribe(result => {
          if (result) {
            this.reload();
          }
        });
    }else{
      this.msg.warning('Vui lòng chọn cơ sở');
    }
  }
}
 

  viewManageSchool(item: any) {
    this.isResizdePopup = false;
    this.titlePopup = 'Danh sách người khuyết tật';
    this.heightModal = this.caculateHeightPopup(window.innerHeight) + 'px';
    this.widthModal = 1300 + 'px';
    this.dialogRef = this.modalService.create({
      nzTitle: this.titlePopupElement,
      nzContent: DanhSachNguoiKhuyetTatComponent,
      nzStyle: { top: '30px' },
      nzMaskClosable: false,
      nzBodyStyle: {
        overflow: 'auto',
        height: this.caculateHeightPopup(window.innerHeight) + 'px'
      },
      nzComponentParams: {
        dataTransmission: item,
      },
      nzWidth: 1300
    });
    // const instance = dialogRef.getContentComponent();
    this.dialogRef.afterClose.subscribe(result => {
      if (result) {
        this.reload();
      }
    });
  }

  addSchool(item: any) {
    this.isResizdePopup = false;
    this.titlePopup = 'Chọn người khuyết tật';
    this.heightModal = this.caculateHeightPopup(window.innerHeight) + 'px';
    this.widthModal = 1300 + 'px';
    this.dialogRef = this.modalService.create({
      nzTitle: this.titlePopupElement,
      nzContent: ThemNguoiKhuyetTatComponent,
      nzStyle: { top: '30px' },
      nzMaskClosable: false,
      nzBodyStyle: {
        overflow: 'auto',
        height: this.caculateHeightPopup(window.innerHeight) + 'px'
      },
      nzComponentParams: {
        dataTransmission: item,
      },
      nzWidth: 1300
    });
    // const instance = dialogRef.getContentComponent();
    this.dialogRef.afterClose.subscribe(result => {
      if (result) {
        this.reload();
      }
    });
  }


  deleteMulti(): void {
    this.setOfCheckedId.forEach(item => {
      this.listGroupSelected.push(item);

    });
    if (this.listGroupSelected.length > 0) {
      const dialogRef = this.modalService.create({
        nzTitle: 'Xóa giáo viên phụ trách',
        nzContent: ConfirmComponent,
        nzComponentParams: {
          description: 'giáo viên đã chọn'
        },
        nzStyle: { top: '20px' },
        nzMaskClosable: false
      });
      dialogRef.afterClose.subscribe((result) => {
        if (result)
          this.service.deleteMulti(this.listGroupSelected).subscribe((res: any) => {
            

            if (res.statusCode == 0) {
              this.utilsService.notifyResponse(res);
              this.reload();
            } else {
              this.utilsService.notifyResponse(res);
            }
          });
      });
    } else {
      this.msg.warning('Vui lòng chọn người dùng để xóa!');
    }
  }
 
  clear() { 
    this.provinceControl.setValue(null);
    this.schoolControl.setValue(null);
    this.typeOfDisabilitysControl.setValue(null);
    this.typeOfPersonnelControl.setValue(null);
    this.commonFilter.StaffCode = ''; 
    this.commonFilter.FullName = '';
    this.commonFilter.StaffCode = '';
    delete this.commonFilter.Gender;
    this.reload();
  }

  updateCheckedSet(id: number, checked: boolean): void {
    if (checked) {
      this.setOfCheckedId.add(id);
    } else {
      this.setOfCheckedId.delete(id);
    }
  }
  onItemChecked(id: number, checked: boolean): void {
    this.updateCheckedSet(id, checked);
    this.refreshCheckedStatus();
  }
  onAllChecked(value: boolean): void {
    this.listOfCurrentPageData.forEach(item => this.updateCheckedSet(item.id, value));
    this.refreshCheckedStatus();
  }

  onCurrentPageDataChange($event: any[]): void {
    this.listOfCurrentPageData = $event;
    this.refreshCheckedStatus();
  }

  refreshCheckedStatus(): void {
    this.checked = this.listOfCurrentPageData.every(item => this.setOfCheckedId.has(item.id));
    this.indeterminate = this.listOfCurrentPageData.some(item => this.setOfCheckedId.has(item.id)) && !this.checked;
  }

  exportExcel() {
    // document.getElementById('btnvF').click(); 
      this.service.exportExcel(this.commonFilter).subscribe((data) => {
        var downloadURL = window.URL.createObjectURL(data);
        var link = document.createElement('a');
        link.href = downloadURL;
        link.download = 'DanhSachGiaoVienPhuTrach.xlsx';
        link.click();
      }); 
  }
  handlerResizePopup(){
    this.isResizdePopup = !this.isResizdePopup;
    let width = this.widthModal;
    let height =this.heightModal;
    let top = 30;
    if(this.isResizdePopup === true){
      width = window.innerWidth + 'px';
      top = 15;
      height = this.caculateHeightPopup(window.innerHeight) + 50 + 'px';
    }
    this.dialogRef.updateConfig({
      nzWidth: width,
      nzStyle: { 
        top: top + 'px',
      },
      nzBodyStyle: {
        overflow: 'auto',
        maxheight: height,
        height: height,
      }
    });
  }
  ngOnDestroy(): void {
    this.$unSubscribe.next();
    this.$unSubscribe.complete();
}

}
